import React from 'react';

export const arrowScrollToTop = (
  <svg
    width="16"
    height="25"
    viewBox="0 0 16 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.01841 0.0428432L8.05278
    0.0102539L15.6742 7.25758L14.0756
    8.70713L8.92868 3.88391V25H7.14296V3.85222L1.96216
    8.70713L0.399658 7.25758L8.00323 0.0102539L8.01885
     0.0428432H8.01841Z"
      fill="white"
    />
  </svg>
);
